export const firebaseConfig = {
  apiKey: "AIzaSyCGcCLeIxlWmt_b_Xp_w8uh7wz8l2WgP8s",
  authDomain: "social-ocean-e5f8f.firebaseapp.com",
  databaseURL: "https://social-ocean-e5f8f.firebaseapp.com",
  projectId: "social-ocean-e5f8f",
  storageBucket: "social-ocean-e5f8f.appspot.com",
  messagingSenderId: "460745887360",
  appId: "1:273756955984:web:8781359cfc2d4fca40f855",
  measurementId: "G-WM9412EXTP"
};